import request from '@/utils/request';

export const getClueShortLink = () => request({
  url: '/api/ecwechat/chamber/ysh-clue/wechatAuth/getClueShortLink'
})

export const getAlbumDetail = albumId => request({
  url: `/api/ecwechat/v1.0/ysh-album/get/${albumId}/v1`
})

export const getSubAlbumList = albumId => request({
  url: `/api/ecwechat/v1.0/ysh-sub-album/list/${albumId}`
})

export const getAlbumImageList = ({ albumId, subAlbumId, ...params }) => request({
  url: `/api/ecwechat/v1.0/ysh-sub-album/activity/imgOldList/${albumId}/${subAlbumId}`,
  params
})
/**
 * 云商卡用户协议
 * GET /wechat/chamberCard/agreement
 * 接口ID：113240759
 * 接口地址：https://app.apifox.com/project/3223850/apis/api-113240759
 * @returns {Promise<unknown>}
 */
export const getYscardAgreement = () => request({
  url: '/api/ecwechat//wechat/chamberCard/agreement'
})

// 微信公众号加密方法
export const getOpenWxToken = (url) => request({
  url: '/api/ecwechat/wechat/getOpenWxToken',
  method: 'post',
  params: { url }
})
